var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.92683V8.75H7.07317L12.4527 3.37043L10.6296 1.54726L5.25 6.92683ZM13.8578 1.96538C14.0474 1.77577 14.0474 1.46704 13.8578 1.27743L12.7226 0.142207C12.533 -0.0474024 12.2242 -0.0474024 12.0346 0.142207L11.1449 1.03191L12.9681 2.85508L13.8578 1.96538Z",
    fill: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.0625V7C14 6.475 13.65 6.125 13.125 6.125C12.6 6.125 12.25 6.475 12.25 7V10.0625C12.25 11.2875 11.2875 12.25 10.0625 12.25H3.9375C2.7125 12.25 1.75 11.2875 1.75 10.0625V3.9375C1.75 2.7125 2.7125 1.75 3.9375 1.75H7C7.525 1.75 7.875 1.4 7.875 0.875C7.875 0.35 7.525 0 7 0H3.9375C1.75 0 0 1.75 0 3.9375V10.0625C0 12.25 1.75 14 3.9375 14H10.0625C12.25 14 14 12.25 14 10.0625Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes2);
export default __webpack_public_path__ + "static/media/Notes_2.54241610.svg";
export { ForwardRef as ReactComponent };